<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{
        $t('homePage.notificationStatus')
      }}</b>
    </div>
    <ts-loading-banner :loading="loading">
      <div class="overflow-auto" style="min-height: 5rem; max-height: 10rem">
        <div
          class="widget-list widget-list-rounded m-b-10"
          v-if="status.length > 0"
        >
          <a
            href="#"
            class="widget-list-item ts-whitespace-no-wrap"
            v-for="(s, index) in status"
            :key="index"
            @click.prevent="homework(s)"
          >
            <div class="widget-list-media icon">
              <i
                class="text-white"
                :class="[(bgName = randomBackground()), s.icon]"
              ></i>
            </div>
            <div class="widget-list-content">
              <h4 class="widget-list-title">{{ s.status_name }}</h4>
            </div>
            <div class="widget-list-action text-right">
              <span class="badge badge-primary m-r-2" :class="bgName">{{
                getTotalByStatus({ status_id: s.status_id })
              }}</span>
              <i class="fa fa-angle-right fa-lg text-muted"></i>
            </div>
          </a>
        </div>
        <div class="widget-list widget-list-rounded m-b-10 inverse-mode" v-else>
          <a class="widget-list-item ts-whitespace-no-wrap">
            <div class="widget-list-content text-center">
              <h4 class="widget-list-title">
                {{ $t('homePage.noNotificationStatus') }}
              </h4>
            </div>
          </a>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'status',
  data() {
    return {
      loading: false,
      status: [],
      backgrounds: [
        'bg-indigo',
        'bg-blue',
        'bg-purple',
        'bg-pink',
        'bg-red',
        'bg-orange',
        'bg-green',
        'bg-teal',
        'bg-primary',
        'bg-success',
        'bg-info',
        'bg-warning',
        'bg-danger'
      ]
    }
  },
  computed: {
    ...mapState('home/teacherHomework', ['resources']),
    ...mapGetters('home/teacherHomework', ['getTotalByStatus'])
  },
  methods: {
    setData() {
      this.status = [
        {
          icon: 'fas fa-book',
          status_id: false,
          status_name: 'Homework Pending'
        },
        {
          icon: 'fas fa-book-reader',
          status_id: true,
          status_name: 'Homework Sent'
        }
      ]
      setInterval(() => {
        this.loading = false
      }, 900)
    },
    randomBackground() {
      return this.backgrounds[
        Math.floor(Math.random() * this.backgrounds.length)
      ]
    },
    homework(record) {
      this.$store.commit(
        'home/teacherHomeworkLinkFromHome/SET_HOMEWORK_STATUS',
        record.status_id
      )
      this.$router.push({
        name: 'teacher-homework'
      })
    }
  },
  watch: {
    resources: debounce(function(value) {
      if (value) {
        this.loading = true
        this.status = []
        this.setData()
      }
    }, 500)
  }
}
</script>
